<template>
  <div class="home">
    <div class="body_html">
      <h1>发票详情</h1>
      <div class="wei_body">
        <div class="tianjia">
          <div class="sconsume">
            <div class="body_nones">
              <el-form ref="formMf" label-width="150px" :model="formMf">
                <el-form-item
                  label="名称："
                  style="display: inline-block; width: 50%"
                >
                  <el-input
                    clearable
                    v-model="tableData.enterpriseName"
                    :disabled="true"
                  ></el-input>
                </el-form-item>
                <el-form-item
                  label="纳税人识别号："
                  style="display: inline-block; width: 50%"
                  prop="pay_number"
                >
                  <el-input
                    clearable
                    v-model="tableData.pay_number"
                    :disabled="true"
                  ></el-input>
                </el-form-item>
                <el-form-item
                  label="电话："
                  style="display: inline-block; width: 50%"
                  prop="tel_phone"
                >
                  <el-input
                    clearable
                    v-model="tableData.tel_phone"
                    :disabled="true"
                  ></el-input>
                </el-form-item>
                <el-form-item
                  label="开户银行账号："
                  style="display: inline-block; width: 50%"
                  prop="account_number"
                >
                  <el-input
                    clearable
                    v-model="tableData.account_number"
                    :disabled="true"
                  ></el-input>
                </el-form-item>
                <el-form-item
                  label="开票金额："
                  style="display: inline-block; width: 50%"
                >
                  <el-input
                    clearable
                    v-model="tableData.money"
                    :disabled="true"
                  ></el-input>
                </el-form-item>
                <el-form-item
                  label="收货人姓名："
                  style="display: inline-block; width: 50%"
                  prop="get_name"
                >
                  <el-input
                    clearable
                    v-model="tableData.get_name"
                    :disabled="true"
                  ></el-input>
                </el-form-item>
                <el-form-item
                  label="详细地址："
                  style="display: inline-block; width: 100%"
                  prop="address_detail"
                >
                  <el-input
                    clearable
                    v-model="tableData.address_detail"
                    :disabled="true"
                  ></el-input>
                </el-form-item>

                <el-form-item style="display: inline-block; width: 100%">
                  <el-button
                    type="primary"
                    @click="conceals=true"
                    style="margin: 0 auto"
                    >审批</el-button
                  >
                  <el-button
                    type="primary"
                    @click="conceal=true"
                    style="margin-left: 30px"
                    >驳回</el-button
                  >
                </el-form-item>
              </el-form>
            </div>
          </div>
          <el-dialog title="驳回内容" center :visible.sync="conceal" width="30%">
            <el-form ref="form" label-width="80px">
              <el-form-item label="驳回内容">
                <el-input clearable v-model="monerto" type="textarea" autosize="true"></el-input>
              </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
              <el-button @click="conceal = false">取 消</el-button>
              <el-button type="primary" @click="moneyto()"
                >提 交</el-button
              >
            </span>
          </el-dialog>
          <el-dialog title="审批内容" center :visible.sync="conceals" width="30%">
            <el-form ref="form" label-width="80px">
              <el-form-item label="审批内容">
                <el-input clearable v-model="monertoss" type="textarea" autosize="true"></el-input>
              </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
              <el-button @click="conceals = false">取 消</el-button>
              <el-button type="primary" @click="onSubmit()"
                >提 交</el-button
              >
            </span>
          </el-dialog>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import qs from "qs";
export default {
  data() {
    return {
      username: {},
      buner: {},
      fapiaoliang: true,
      conceal:false,
      conceals:false,
      name: {},
      page: "",
      pone: [],
      money: "",
      tableData: {},
      formMf: {
        pay_number: "",
        tel_phone: "",
        account_number: "",
        get_name: "",
        address_detail: "",
        enterpriseName: "",
      },
      monerto:"",
      monertoss:"",
    };
  },
  mounted() {
    // 页面刷新就请求到数据渲染到页面中
    if (window.sessionStorage.getItem("userinfo")) {
      let userinfo = JSON.parse(window.sessionStorage.getItem("userinfo"));
      this.username = userinfo;
    }
    this.buner = this.$route.query.val;
    this.onSubmitss();
  },
  methods: {
    onSubmitss() {
      this.axios
        .post(
          "/api/Agent/getInvoiceOne",
          qs.stringify({
            agenttoken: this.username.agenttoken,
            agent_id: this.username.id,
            id: this.buner.id,
          }),
          { headers: { "Content-Type": "application/x-www-form-urlencoded" } }
        )
        .then((res) => {
          this.tableData = res.data.data;
          if (res.data.msg == "登录超时") {
            this.$router.push("/mine");
          }
        })
        .catch(function (err) {});
    },
    onSubmit() {
      this.axios
        .post(
          "/api/Agent/checkInvoice",
          qs.stringify({
            agenttoken: this.username.agenttoken,
            username: this.username.username,
            status: "2",
            id: this.buner.id,
            check_content:this.monertoss
          }),
          { headers: { "Content-Type": "application/x-www-form-urlencoded" } }
        )
        .then((res) => {
          if (res.data.msg == "登录超时") {
            this.$router.push("/mine");
          }
           if (res.data.code == 1) {
              this.$message({
                message: res.data.msg,
                type: "success",
              });
              this.$router.push("/mine/agency/invoiceand");
            } else if (res.data.code == 0) {
              this.$message.error(res.data.msg);
            }
        })
        .catch(function (err) {});
    },
    moneyto(){
        this.axios
        .post(
          "/api/Agent/checkInvoice",
          qs.stringify({
            agenttoken: this.username.agenttoken,
            username: this.username.username,
            status: "3",
            id: this.buner.id,
            check_content:this.monerto
          }),
          { headers: { "Content-Type": "application/x-www-form-urlencoded" } }
        )
        .then((res) => {
          if (res.data.msg == "登录超时") {
            this.$router.push("/mine");
          }
           if (res.data.code == 1) {
              this.$message({
                message: res.data.msg,
                type: "success",
              });
              this.$router.push("/mine/agency/invoiceand");
            } else if (res.data.code == 0) {
              this.$message.error(res.data.msg);
            }
        })
        .catch(function (err) {});
    },
  },
};
</script>
<style lang="scss" scoped>
::v-deep .el-table th,
.el-table tr {
  background-color: #eee;
}
::v-deep .el-table thead {
  color: #ffffff;
}
.home {
  width: 100%;
  height: 100%;
}
.body_html {
  width: 100%;
  height: 100%;
}
.wei_body {
  margin-top: 20px;
  width: 100%;
  height: 90%;
  background-color: #ffffff;
  box-shadow: 0px 1px 6px 0px rgba(0, 0, 0, 0.2);
}
.tongg {
  color: green;
}
.dengdai {
  color: rgb(64, 158, 255);
}
.bohui {
  color: red;
}
.tianjia {
  width: 100%;
  height: 100%;
}
.tianjia > main {
  font-size: 26px;
  /* margin-bottom: 40px; */
}
.bule {
  width: 100%;
  height: 69px;
  background-color: #2890dd;
  z-index: 10;
  position: absolute;
  top: 0px;
  left: 0px;
}
nav {
  width: 100%;
  height: 80px;
  // background-color: red;
  border-bottom: 1px solid #eeeeee;
}
nav > span {
  padding: 20px;
  line-height: 80px;
  cursor: pointer;
}
.blue {
  color: #fff;
  background-color: #298edb;
}
.sconsume {
  width: 100%;
  margin-top: 10px;
}
.invoice {
  width: 100%;
  height: 100%;
}
.body_none {
  width: 100%;
  height: 550px;
  margin: 0 auto;
  padding: 30px;
  overflow: hidden;
  overflow-y: auto;
  position: relative;
}
.body_nones {
  width: 80%;
  height: 100%;
  margin: 0 auto;
  padding: 30px;
}
</style>

